const tm = {
  online_airport_board: "Onlaýn aeroport tablosy",
  scoreboard: "Tablo",
  services: "Hyzmatlar",
  location_map: "Kartada ýerleşýän ýerimiz",
  Location: "Ýerleşýän ýerimiz",
  location: "Kartada ýerleşýän ýerimiz",
  agreement_text:
    "Saýta girmek bilen siz Gizlinlik syýasaty hem-de şahsy maglumatlary ýygnamak we işlemek düzgünleri bilen ylalaşýarsyňyz",
  login_title_text: "Hasabyňyza giriň",
  login_text: "Giriş",
  password_text: "Parol",
  forgot_password_text: "Parolyňyzy unutdyňyzmy?",
  reset_password_text: "Ony şu ýerde dikeldip bilersiňiz",
  registration_text: "Hasaba durmak",
  enter_text: "Girmek",
  new_customer: "Täze müşderimi?",
  logged_user_text: "Eýýäm hasabyňyz barmy?",
  invalid_password: "Iň azyndan 6 belgi",
  invalid_email: "Nädogry e-poçta",
  required: "Hökmany meýdan",
  travel_time: "Ýol wagty",
  flight: "Uçuş",
  flights: "Uçuşlar",
  terminal: "Terminal",
  baggage: "Bagaž",
  hand_luggage: "El goşy",
  refund_ticket: "Petegi yzyna gaýtarmak",
  change: "Petegi çalyşmak",
  no_refund: "Yzyna gaýtarylmaýar",
  yes_refund: "Yzyna gaýtarylýan petek",
  no_change: "Petek çalşylmaýar",
  yes_change: "Petegi çalyşmak",
  yes_baggage: "Bagaž",
  no_baggage: "Bagaž ýok",
  yes_hand_luggage: "El goşy",
  no_hand_luggage: "El goşy ýok",
  show_rules: "Düzgünleri görkez",
  total: "Jemi",
  passengers: "Ýolagçylar",
  select_from_list: "Sanawdan saýlaň",
  name_as_in_document: "Resminamadaky ýaly ady",
  middlename_as_in_document: "Resminamadaky ýaly atasynyň ady",
  surname_as_in_document: "Resminamadaky ýaly familiýasy",
  date_of_birth: "Doglan senesi",
  gender: "Jynsy",
  citizenship: "Raýatlygy",
  age: "Ýaşy",
  document: "Resminama",
  payer: "Töleýji",
  for_payer_mess:
    "Bronlaşdyrmak baradaky maglumaty e-poçtaňyza ibereris. Telefon uçuş tertibi üýtgände gyssagly habar bermek üçin gerek ",
  series_and_number: "Resminamanyň belgisi",
  valid_until: "Hereket ediş möhleti",
  airline_bonus_card: "Awiakompaniýanyň bonus kartasy",
  number_bonus_card: "Bonus kartanyň belgisi",
  phone_number: "Telefon belgisi",
  contact_number: "+998 97 985 00 06 (her gün 9:00-dan 23:00-a çenli)",
  email: "E-poçta",
  workH: "Iş wagty",
  working_hours: "Her gün 9:00-dan 20:00-a çenli",
  how_to_read_rules: "Tarif düzgünlerini nädip okamaly",
  tariff_rules: "Tarif düzgünleri",
  book_and_proceed_to_payment: "Bronlaşdyryp, tölege geçmek",
  agreement_book_text: "«Bronlaşdyryp, tölege geçmek» düwmesine basmak bilen siz kabul edýärsiňiz",
  agreement_book_link: "awiakompaniýanyň tarif düzgünlerini",
  everywhere_local_time: "Ähli ýerde ugramagyň we gelmegiň ýerli wagty görkezilen",
  duration: "dowamlylygy",
  in: "içinde",
  no_data_contact_technical_support: "Maglumat ýok. Tehniki goldawa ýüz tutuň.",
  back_to_orders: "Sargytlara dolan",
  incorrect_date_from_adt: "Uly adam üçin nädogry sene",
  incorrect_date_from_chd: "Çaga üçin nädogry sene",
  incorrect_date_from_inf: "Bäbek üçin nädogry sene",
  incorrect_date: "Nädogry sene",
  check_date_and_change_doc: "Doglan senesini barlaň ýa-da resminamanyň görnüşini üýtgediň",
  warning_inf_date: "Awiakompaniýa bäbegiň uçuşa goýberilendigi baradaky güwänamany soramagy mümkin",
  ps_should_be_10_digits: "Russiýanyň içerki pasporty 10 sandan ybarat",
  psp_should_be_9_digits: "Russiýanyň daşary ýurt pasporty 9 sandan ybarat",
  incorrect_doc_number: "Resminamanyň belgisi nädogry",
  hint_for_ps_doc: "Pasportyň belgisini 1234567890 görnüşinde giriziň",
  hint_for_psp_doc: "Pasportyň belgisini 123456789 görnüşinde giriziň",
  hint_for_sr_doc: "Dogluş şahadatnamasynyň belgisini IXЯЯ123456 görnüşinde giriziň",
  hint_for_np_doc: "Resminamanyň belgisini giriziň",
  male: "Erkek",
  female: "Aýal",
  russian_passport: "Russiýanyň içerki pasporty",
  birth_certificate: "Russiýanyň dogluş şahadatnamasy",
  international_passport: "Russiýanyň daşary ýurt pasporty",
  foreign_document: "Daşary ýurt resminamasy",
  national_passport_id_card: "Milli pasport (ID karta)",
  domestic_birth_certificate: "Dogluş şahadatnamasy",
  place_one: "orun",
  place_more: "orun",
  place_many: "orun",
  customer_support: "Müşderi goldawy",
  financial_matters: "Maliýe meseleleri",
  agreement_footer_text: "Materiallary ýazmaça rugsatsyz ulanmak gadagan ",
  flight_schedule: "Uçuş tertibi",
  offer: "Teklip",
  question_answer: "Soraglar we jogaplar",
  jobs: "Iş orunlary",
  facebook: "Facebook",
  about_us: "Biz barada",
  currency: "Pul birligi",
  language: "Dil",
  search: "Gözleg",
  personal_info: "Şahsy maglumatlar",
  personal_area: "Şahsy hasap",
  not_found_page: "Açjak bolan sahypaňyz tapylmady",
  to_main: "Baş sahypa",
  log_out: "Çykmak",
  session: "Sessiýa",
  error_500_text:
    "Bir zat ýalňyş gitdi öýdýäris, ýöne biz mesele barada eýýäm bilýäris we ony düzetmek ugrunda işleýäris. Amatsyzlyk üçin ötünç soraýarys. ",
  lang_ru: "Rus dili",
  lang_en: "Iňlis dili",
  balance: "Balans",
  otb: "Balans",
  own_funds: "Öz serişdeleri",
  credit_balance: "Karz balansy",
  credit_line: "Karz çägi",
  no: "Ýok",
  for_route: "Ugur üçin",
  to_result_search: "Gözleg netijelerine",
  only_a_z_space: "Diňe latyn harplary we boşluk",
  only_a_z: "Diňe latyn harplary",
  invalid_phone: "Telefon belgisi nädogry",
  min_2_symbol: "Iň azyndan 2 belgi",
  select_value_from_list: "Sanawdan bahany saýlaň",
  check_date: "Senäni barlaň",
  incorrect_number: "Kartanyň belgisi nädogry",
  incorrect_cvc: "Kod nädogry",
  incorrect_card_holder: "Karta eýesiniň ady nädogry",
  incorrect_card_month: "Aý nädogry",
  incorrect_card_year: "Ýyl nädogry",
  code: "Kod",
  message: "Habar",
  close: "Ýap",
  error_message_part_1:
    "Bir zat ýalňyş gitdi öýdýäris. Meseläniň sebäbini anyklamagymyz üçin tehniki goldawa ýüz tutuň",
  error_message_part_2: "we sessiýanyň belgisini aýdyň",
  error_message_part_3: "Habary ýapanyňyzdan soň hyzmatyň baş sahypasyna geçirilersiňiz. ",
  choose: "Saýla",
  collapse: "Ýygna",
  looking_tickets: "Petekleri gözleýäris",
  wait_please: "Garaşyň, haýyş edýäris",
  we_issue_tickets: "Petekleri resmileşdirýäris, bu köp wagt almaýar",
  created: "Döredildi",
  left: "Galdy",
  less_than_minute: "bir minutdan az",
  help: "Kömek",
  exchange_and_return_rules: "Çalyşmak we yzyna gaýtarmak: düzgünler",
  after_flight: "Uçuşdan soň",
  go_to_section: "Bölüme geç",
  next: "Indiki",
  earlier: "Öňki",
  not_book_tickets: "Sizde bronlaşdyrylan sargyt ýok",
  route_from: "Nireden",
  route_to: "Nirä",
  date_from: "Sene",
  date_to: "Dolanmak senesi",
  find: "Gözle",
  add_route: "Uçuş goş",
  one_way: "Bir tarapa",
  two_way: "Iki tarapa",
  multi_way: "Birnäçe uçuş",
  economy: "Ekonom",
  business: "Biznes",
  first: "Birinji",
  all_class: "Islendik klas",
  adt_main_label: "Uly adam",
  inf_main_label: "Bäbek",
  chd_main_label: "Çaga",
  adt_second_label: "12 ýaşdan uly",
  chd_second_label: "2-12 ýaş",
  inf_second_label: "2 ýaşa çenli (orunsyz)",
  inf_with_seat_second_label: "orun bilen",
  passenger_1: "Bir ýolagçy",
  passenger_2: "Iki ýolagçy",
  passenger_3: "Üç ýolagçy",
  passenger_4: "Dört ýolagçy",
  passenger_5: "Bäş ýolagçy",
  passenger_6: "Alty ýolagçy",
  agents: "Agentler üçin",
  passenger_7: "Ýedi ýolagçy",
  passenger_8: "Sekiz ýolagçy",
  passenger_9: "Dokuz ýolagçy",
  only_there: "Bir tarapa",
  roundtrip: "Iki tarapa",
  your_profile: "Siziň profiliňiz",
  client_name: "Müşderiniň ady",
  client_code: "Müşderiniň kody",
  partner_code: "Hyzmatdaşyň kody",
  partner_name: "Hyzmatdaşyň ady",
  partner_currency: "Hyzmatdaşyň pul birligi",
  current_balance: "Häzirki balans",
  debt: "Bergi",
  credit_limit: "Karz çägi",
  deposit: "Goýum",
  change_password: "Paroly üýtget",
  old_password: "Häzirki paroly giriziň",
  new_password: "Täze parol",
  confirmation_password: "Paroly tassyklaň",
  save: "Sakla",
  passwords_must_match: "Parollar gabat gelmeli",
  password_changed_successfully: "Parol üstünlikli üýtgedildi",
  departure_title: "Ugramak",
  there_title: "Gidiş",
  back_title: "Dolanyş",
  validates_flights: "uçuşlary tassyklaýar",
  pay_for_your_reservation: "bronlaşdyrylan sargydy tölemek üçin",
  hour_short: "sag",
  day_short: "g",
  minutes_short: "m",
  minutes_short_3: "min",
  on_way: "Ýolda",
  no_transfers: "Göni uçuş",
  class: "Klas",
  tariff_options: "Tarifiň mümkinçilikleri",
  with_luggage: "Bagaž bilen",
  without_luggage: "Bagažsyz",
  quick_picks_title: "Çalt saýlaw",
  quick_optimal: "Amatly",
  quick_cheapest: "Iň arzan",
  quick_fastest: "Iň çalt",
  quick_transfers: "{{count}} geçiş",
  quick_pick_hint: "Sanawda görkezmek",
  hours_short: "s",
  airline_combination: "Awiakompaniýalaryň utgaşmasy",
  with_airline_combination: "Utgaşmalar",
  without_airline_combination: "Bir petek",
  vtrip_notice: "Bu uçuş aýratyn petekler bilen resmileşdirilýär. Olary yzyna gaýtarmak we çalyşmak biri-birine bagly däl. Eger bir petek boýunça tertip üýtgese ýa-da gatnaw ýatyrylsa, beýleki petegi yzyna gaýtarmak we çalyşmak meýletin tertipde, tarifiň düzgünlerine görä ýerine ýetirilýär.",
  no_timelimit: "Töleg möhleti barada maglumat ýok",
  legal_information: "Hukuk maglumaty",
  opportunities: "Mümkinçilikler",
  same_routes: "🔗 Meňzeş ugurlar",
  routes: "Ugurlar",
  rules_of_use: "Ulanyş düzgünleri",
  privacy_policy: "Gizlinlik syýasaty",
  payment: "Töleg",
  provider: "Üpjün ediji",
  price: "Baha",
  detail: "Giňişleýin",
  label_price_by_min: "Baha (ýokarlanýan)",
  label_price_by_max: "Baha (peselýän)",
  transfers: "Aralyk düşelgeler",
  all_flights: "Ähli uçuşlar",
  without_transfers: "Göni uçuş",
  one_transfer: "1 aralyk düşelge",
  many_transfer: "2 we ondan köp aralyk düşelge",
  not_found_recomm_first_text: "Soragyňyza laýyk gelýän petek tapyp bilmedik ",
  not_found_recomm_second_text: "Başga seneler ýa-da aeroport bilen gaýtadan synanyşyň ",
  not_found_recomm_by_filters: "Süzgüçleriň şertlerini üýtgediň",
  flight_details: "Uçuş barada jikme-jik",
  change_tariff: "Tarifi üýtget",
  tariffs: "Tarifler",
  teh_stop: "Tehniki düşelge",
  transfer: "Aralyk düşelge",
  local_time_message: "Ugramagyň we gelmegiň ýerli wagty",
  route_tariffs_message: "Tarif ähli ugur üçin güýjünde",
  airlines: "Awiakompaniýalar",
  airports: "Aeroportlar",
  departure: "Ugramak",
  arrival: "Gelmek",
  departure_time: "Ugraýan wagty",
  arrival_time: "Gelýän wagty",
  flight_number: "Uçuşyň belgisi",
  multiple_numbers_separated_by_spaces: "Birnäçe belgi boşluk bilen bölünýär",
  lowcost: "lowcost",
  transfer_1: "aralyk düşelge",
  transfer_2_4: "aralyk düşelge",
  transfer_5: "aralyk düşelge",
  free_seats_0: "boş orun ýok",
  free_seats_1: "orun",
  free_seats_2_4: "orun",
  free_seats_5: "orun",
  one_adt: "Uly adam",
  more_adt: "Uly adamlar",
  many_adt: "Uly adamlar",
  one_chd: "Çaga",
  more_chd: "Çagalar",
  many_chd: "Çagalar",
  one_inf: "Bäbek",
  more_inf: "Bäbekler",
  many_inf: "Bäbekler",
  flight_one: "uçuş",
  flights_more: "uçuş",
  flights_many: "uçuş",
  found_one: "Tapyldy",
  found_more: "Tapyldy",
  flight_overview: "Uçuşa syn",
  to_top: "Ýokaryk",
  book: "Bronlaşdyrmak",
  buyer: "Töleýji",
  pnr: "Bron kody / PNR",
  online_registration_locator: "Onlaýn hasaba alyş lokatory",
  route_information: "Uçuş barada maglumat",
  order: "Sargyt",
  flights_tickets: "Petekler",
  void_text: "Sargydy islendik wagt ýatyryp bilersiňiz",
  void_order: "Sargydy ýatyr",
  support_chat: "Goldaw çaty",
  payment_method: "Töleg usullary",
  payment_with_balance: "Balans bilen tölemek",
  payment_with_card: "Karta bilen tölemek",
  info_account: "Maglumat hasaby",
  get_tickets: "Petekleri resmileşdirmek",
  left_before_the_time_limit: "Galan wagt",
  not_ticketed_warning:
    "⚠️ Möhüm: Häzirki wagtda siziň bronuňyz saklanýar, emma petek entek satyn alynmady. Töleg edilmezden öň awiakompaniýa bahany üýtgedip, ýerleriň elýeterliligini üýtgedip ýa-da brony ýatyryp biler. Häzirki bahany saklamak üçin tölegi mümkin boldugyça tiz geçirmegiňizi maslahat berýäris.",
  expires: "Gutarýar",
  payment_timed_out: "Töleg wagty gutardy",
  cashback_label: "Keşbek",
  cashback_accrued_label: "Keşbek geçirildi",
  cashback_hint: "Keşbek uçuşdan soň şahsy otagyňyzyň balansyna geçiriler (diňe hasaba alnan ulanyjylar üçin)",
  payment_thanks_title: "Tölegiňiz üçin sag boluň!",
  payment_thanks_text: "E-poçtaňyzy barlaň ýa-da biziň bilen habarlaşyň.",
  payment_pending_warning:
    "⚠️ Möhüm: Häzirki wagtda siziň bronuňyz saklanýar, emma petek entek satyn alynmady. Töleg edilmezden öň awiakompaniýa bahany üýtgedip, ýerleriň elýeterliligini üýtgedip ýa-da brony ýatyryp biler. Häzirki bahany saklamak üçin tölegi mümkin boldugyça tiz geçirmegiňizi maslahat berýäris.",
  time_expired: "Wagt gutardy",
  order_created: "Sargyt döredildi",
  return_ticket: "Petegi yzyna gaýtarmak",
  exchange_ticket: "Petegi çalyşmak",
  download_itinerary_receipt: "Ýol resminamasyny ýükläp almak",
  order_cost: "Sargydyň bahasy",
  invoice_for_payment: "Hasap-faktura",
  void_in_process: "Sargyt ýatyrylýar",
  initial: "Sargyt döredildi",
  in_progress: "Bronlaşdyryldy",
  success: "Üstünlikli töleg, petekler resmileşdirildi",
  partially_success: "Bölekleýin üstünlikli sargyt",
  booking_fail: "Bronlaşdyrmak ýalňyşlygy",
  prebook_error_title: "Uçuşy ýükleme ýalňyşlygy",
  prebook_error_search_again: "Gaýtadan gözle",
  invalid_passport_format_title: "Pasportyň formaty nädogry",
  invalid_passport_format_desc: "Gazagystan raýatlygy üçin pasportyň seriýasyny we belgisini barlaň.",
  invalid_passport_format_fix: "Maglumaty düzet",
  order_fail: "Sargyt döretmek ýalňyşlygy",
  pay_fail: "Töleg ýalňyşlygy",
  order_cancel_from_client: "Sargyt müşderi tarapyndan ýatyryldy",
  order_cancel_from_admin: "Sargyt administrator tarapyndan ýatyryldy",
  order_cancel_by_job: "Sargyt wagt çägi boýunça ýatyryldy",
  order_cancel_error: "Sargydy ýatyrmak ýalňyşlygy",
  application_refund: "Yzyna gaýtarmak arzasy döredildi",
  partial_refund: "Sargydyň bölekleýin yzyna gaýtarylmagy",
  order_cancel_by_gds: "Sargyt wagt çägi boýunça ýatyryldy",
  refund: "Sargydyň doly yzyna gaýtarylmagy",
  ticketing_done: "Üstünlikli töleg, petekler resmileşdirildi",
  pay_success: "Üstünlikli töleg, petekler resmileşdirilýär",
  booking_done: "Bronlaşdyryldy",
  exchange: "Petegi çalyşmak",
  void: "Sargyt ýatyryldy",
  ticketing_fail: "Petekleri resmileşdirmek ýalňyşlygy",
  year_one: "ýyl",
  year_more: "ýyl",
  years: "ýyl",
  day_one: "gün",
  day_more: "gün",
  days: "gün",
  hour_one: "sagat",
  hour_more: "sagat",
  hours: "sagat",
  minute_one: "minut",
  minute_more: "minut",
  minutes: "minut",
  second_one: "sekunt",
  second_more: "sekunt",
  seconds: "sekunt",
  passenger_list: "Ýolagçylaryň sanawy",
  your_name: "Adyňyz",
  search_order: "Sargyt gözlemek",
  locator: "Lokator",
  cancel: "Ýatyr",
  passenger_name: "Ýolagçynyň familiýasy",
  do_not_find_order_message: "Sargyt tapylmady. Gözleg şertlerini üýtgediň",
  orders: "Sargytlar",
  contract_settings: "Şertnamanyň sazlamalary",
  main: "Esasy",
  users: "Ulanyjylar",
  affiliated_companies: "Bagly kompaniýalar",
  all_orders_label: "Ähli sargytlar",
  book_done_label: "Bronlaşdyryldy",
  pay_done_label: "Tölendi",
  ticket_done_label: "Petekler resmileşdirildi",
  cancel_done_label: "Ýatyryldy",
  wait_refund_label: "Yzyna gaýtarylmagyna garaşylýar",
  refund_done_label: "Yzyna gaýtaryldy",
  partial_refund_done_label: "Bölekleýin yzyna gaýtaryldy",
  void_done_label: "Ýatyryldy",
  error_order_label: "Sargyt ýalňyşlygy",
  date_create_from: "Döredilen senesi (başlangyç)",
  order_status_label: "Sargydyň ýagdaýy",
  search_title: "Familiýany, lokatory ýa-da şäheri giriziň",
  date_create_to: "Döredilen senesi (soňky)",
  clear: "Arassala",
  passenger_success_save: "Ýolagçy üstünlikli saklandy",
  payment_with_dpt: "Balans bilen tölemek",
  payment_with_unt: "«Uniteller» bilen tölemek",
  payment_with_spt: "«Corti Milli» bilen tölemek",
  include_your_fees: "siziň ýygymyňyz goşulan",
  before: "çenli",
  your_fees: "Siziň ýygymyňyz",
  month_one: "aý",
  months_more: "aý",
  months: "aý",
  all_passengers: "Ähli ýolagçylar",
  passenger_success_remove: "Ýolagçy üstünlikli pozuldy",
  companies: "Kompaniýalar",
  no_companies: "Kompaniýa ýok",
  no_matches_found: "Gabat gelýän netije tapylmady",
  no_passengers: "Sizde entek saklanan ýolagçy ýok",
  enter_passenger_name: "Ýolagçynyň adyny ýa-da familiýasyny giriziň",
  add_passenger: "Ýolagçy goş",
  your_partner_fees: "Siziň ýygymyňyz",
  type_of_fee: "Ýygymyň görnüşi",
  value: "Bahasy",
  percent: "Göterim",
  saved_successfully: "Üstünlikli saklandy",
  error_saving: "Saklamak ýalňyşlygy",
  percent_from_total: "Jemden göterim",
  percent_from_fare: "Tarifden göterim",
  fix_flat: "Bellenen möçber",
  fix_flat_and_percent_from_total: "Bellenen möçber we jemden göterim",
  fix_flat_and_percent_from_fare: "Bellenen möçber we tarifden göterim",
  reset: "Dikelt",
  invalid_value: "Baha nädogry",
  no_orders_found: "Sargyt tapylmady",
  personal_data: "Şahsy maglumatlar",
  upload: "Ýükle",
  your_logo: "Siziň logotipiňiz",
  image_uploaded_successfully: "Surat üstünlikli ýüklendi",
  upload_logo: "Logotip ýükle",
  image_too_large: "Surat gaty uly",
  image_resolution_too_high: "Suratyň ölçegi gaty uly",
  image_resolution_too_small: "Suratyň ölçegi gaty kiçi",
  rule_for_upload_img_1: "Suratyň formaty .jpg, .png, .jpeg, .gif",
  rule_for_upload_img_2: "Ölçegi 300x100px-den 2000x2000px-e çenli.",
  rule_for_upload_img_3: "Faýlyň göwrümi 4 MB-dan köp bolmaly däl.",
  amount: "Möçber",
  rules_text_1: "Bölümdäki şu jümlelere üns beriň",
  rules_text_2: "petek yzyna gaýtarylmaýar",
  rules_text_3: "uçuşa gelmedik ýagdaýynda petek yzyna gaýtarylmaýar",
  rules_text_4: "Çalyşmagyň düzgünleri şu at bilen bölümde beýan edilýär",
  line: "Setir",
  rules_text_5: "üýtgetmelere rugsat berilmeýändigini, ýagny uçuşyň senelerini üýtgedip bolmajakdygyny aňladýar",
  passenger_data: "Ýolagçynyň maglumatlary",
  comment: "Bellik",
  contact_details: "Habarlaşmak maglumatlary",
  contact_information: "Habarlaşmak üçin maglumat",
  remove: "Poz",
  add_document: "Resminama goş",
  return_avia_rules: "Nädip çalyşmaly ýa-da yzyna gaýtarmaly",
  booking_avia_rules: "Petegi nädip bronlaşdyrmaly",
  created_at: "Döredildi",
  updated_at: "Täzelendi",
  phone: "Telefon",
  create_user: "Ulanyjy döret",
  add: "Goş",
  edit: "Üýtget",
  confirm: "Tassykla",
  successfully_deleted: "Üstünlikli pozuldy",
  error_deleting: "Pozmak ýalňyşlygy",
  mess_want_to_delete: "Pozmak isleýärsiňizmi",
  record_one: "ýazgy",
  record_more: "ýazgy",
  record_many: "ýazgy",
  user_type: "Müşderiniň görnüşi",
  admin_role: "Administrator",
  manager_role: "Menejer",
  user_agent_role: "Agent",
  user_role: "Ulanyjy",
  security_guarantees_unitaller: "Howpsuzlyk kepillikleri",
  activation_title: "Ulanyjyny işjeňleşdirmek",
  confirmation_activation_password: "Paroly tassyklaň",
  enter_activation_password: "Paroly giriziň",
  activation: "Işjeňleşdirme",
  login: "Giriş",
  error_activating_user: "Ulanyjyny işjeňleşdirmek ýalňyşlygy",
  error: "Ýalňyşlyk",
  to_login_form: "Giriş sahypasyna",
  expired_date: "Möhleti geçen",
  refund_button_title: "Yzyna gaýtarmak",
  itinerary_receipt: "Ýol resminamasy",
  action: "Hereket",
  to_pay: "Töleg",
  order_cancel_error_mess: "Sargydy ýatyrmak ýalňyşlygy",
  order_cancel_successfully_mess: "Ýatyrmak üstünlikli boldy",
  partner: "Hyzmatdaş",
  inn: "INN",
  kpp: "KPP",
  logo: "Logotip",
  create_partner: "Hyzmatdaş döret",
  status: "Ýagdaýy",
  add_your_details: "Maglumatlaryňyzy goşuň",
  return_request_created: "Yzyna gaýtarmak arzasy döredildi",
  error_creating_refund_request: "Yzyna gaýtarmak arzasyny döretmek ýalňyşlygy",
  activation_status: "Işjeňleşdirmegiň ýagdaýy",
  placeholder_date_picker: "gg.aa.ýýýý",
  created_company_successfully: "Kompaniýa döredildi",
  error_created: "Döretmek ýalňyşlygy",
  deposit_statement: "Goýum hasabaty",
  transactions: "Amallar",
  weight_unit: "kg",
  credit_funds: "Karz serişdeleri",
  overrun: "Aşa harçlanan",
  transaction_time: "Amalyň wagty",
  before_balance_change: "Balans üýtgemezden öň",
  allow_balance_payment: "Balans bilen tölege rugsat ber",
  approved_balance_request_successfully: "Balans hasabaty baradaky arza tassyklandy",
  error_approved_balance_request_successfully: "Balans hasabaty baradaky arzany tassyklamak ýalňyşlygy",
  balance_payment_request: "Balans bilen töleg soragy",
  balance_payment_approved: "Balans bilen töleg tassyklandy",
  payment_with_uzc: "«Uzcard» bilen tölemek",
  allow_payment: "Tölege rugsat ber",
  statement_request: "Hasabat soragy",
  client: "Müşderi",
  was_changed_to: "şuňa üýtgedildi",
  deposit_statement_request_created: "Goýum hasabaty soragy döredildi",
  registration: "Hasaba durmak",
  error_creating_deposit_statement_request: "Goýum hasabaty soragyny döretmek ýalňyşlygy",
  deposit_statement_request_confirmed: "Goýum hasabaty soragy tassyklandy",
  error_confirming_deposit_statement_request: "Goýum hasabaty soragyny tassyklamak ýalňyşlygy",
  fare: "Tarif",
  fees: "Ýygymlar",
  partner_fees: "Hyzmatdaşyň ýygymlary",
  taxes: "Salgytlar",
  ticket: "Petek",
  pay_for_the_order: "Sargydy töle",
  operating_company: "Uçuşy amala aşyrýan kompaniýa",
  download_charter_certificate: "Çarter güwänamasyny ýükläp al",
  certificate_issued: "Çarter güwänamasy berildi",
  charter: "Çarter",
  service: "Hyzmat",
  income: "Girdeji",
  spending: "Çykdajy",
  remainder: "Galyndy",
  description: "Beýany",
  contract: "Şertnama",
  column_selection: "Sütünleri saýlamak",
  your_commission: "Siziň komissiýaňyz",
  merchant_commission: "Merçantyň komissiýasy",
  no_result: "Netije ýok",
  date: "Sene",
  movement_balance: "Balansdaky serişdeleriň hereketi",
  current_balance_sheet: "Häzirki balans hasabaty",
  indebtedness: "Bergidarlyk",
  date_from_d: "Seneden",
  date_to_d: "Senä çenli",
  order_num: "Sargydyň belgisi",
  order_details: "Sargydyň jikme-jiklikleri",
  flight_info: "Uçuş barada maglumat",
  orders_subtitle: "Uçuş bronlaryňyzy görüň we dolandyryň",
  successful: "Üstünlikli",
  cancelled: "Ýatyryldy",
  timeout: "Wagt gutardy",
  order_cancelled_by_customer: "Sargyt müşderi tarapyndan ýatyryldy",
  order_cancelled_by_time_limit: "Sargyt wagt çägi boýunça ýatyryldy",
  successful_payment_tickets_issued: "Üstünlikli töleg, petekler resmileşdirildi",
  status_refund: "Yzyna gaýtarmak",
  status_exchange: "Çalyşmak",
  status_void: "Ýatyryldy",
  status_error: "Ýalňyşlyk",
  status_pending: "Garaşylýar",
  status_processing: "Işlenilýär",
  status_booked: "Bronlaşdyryldy",
  booking_num: "Bronyň belgisi",
  search_operations: "Amallary gözlemek",
  upload_report: "Hasabaty ýükle",
  payment_with_vsl: "«Corti Milli» bilen tölemek",
  popular_destinations: "Meşhur ugurlar",
  more_options: "Goşmaça mümkinçilikler",
  hide_list: "Sanawy gizle",
  straight: "Göni",
  with_transfer: "Aralyk düşelgeli",
  finances: "Maliýe",
  contacts: "Habarlaşmak",
  all_classes: "Ähli klaslar",
  difficult_routes: "Çylşyrymly ugur düz",
  search_history: "Gözlegiň taryhy",
  go_to_page: "Geç",
  find_tickets: "Petek tap",
  tours_discount: "Amatly turlar we arzanladyşlar",
  last_news: "Soňky habarlar",
  more_details: "Giňişleýin",
  about_company: "Kompaniýa barada",
  distribution: "Distribýusiýa",
  wannatalk: "Gürleşmek isleýärsiňizmi?",
  customer_rew: "Müşderileriň pikirleri",
  my_profile: "Meniň profilim",
  contact_us: "Biz bilen habarlaşyň",
  last_name: "Familiýasy",
  first_name: "Ady",
  father_name: "Atasynyň ady",
  enter_login: "Loginiňizi giriziň",
  enter_name: "Adyňyzy giriziň",
  enter_surname: "Familiýaňyzy giriziň",
  enter_fathname: "Atasynyň adyny giriziň",
  aeroflot: "Aeroflot",
  uz_airways: "Uzbekistan Airways",
  turkish: "Turkish Airlines",
  ural: "Ural Airlines",
  korea: "Korean Air",
  qanot: "Qanot Sharq",
  belavia: "Belavia",
  apgAS: "APG Air Solution",
  pobeda: "Pobeda",
  airastana: "Air Astana",
  flyaristan: "Fly Aristan",
  s7: "S7 Airlines",
  enter_password: "Parolyňyzy giriziň",
  flight_search: "Uçuş gözlegi",
  buy_air_tickets: "Öýden çykman awiapetek satyn alyň",
  log_in: "Girmek",
  welcome_back: "Ýene hoş geldiňiz!",
  return_to_simple_route: "Ýönekeý ugra dolan",
  delete: "Poz",
  max_num_flights: "Uçuşlaryň iň köp sanyny goşduňyz",
  select_dep_date: "Ugramak senesini saýlaň",
  select_return_date: "Dolanmak senesini saýlaň",
  select_class: " Klas saýlaň",
  login_as_user: "Hasabyňyza girmek üçin maglumatlaryňyzy aşakda giriziň.",
  enter_recieved_code: "Alnan kody giriziň",
  come_up_your_pass: "Öz parolyňyzy oýlap tapyň",
  enter_valid_mail: "Dogry e-poçta giriziň",
  must_field_characters: "Meýdanda iň azyndan 6 belgi bolmaly",
  register_to_save_data: "Maglumatlaryňyzy saklamak üçin hasaba duruň",
  ins_main_label: " Bäbek",
  ins_second_label: " 2 ýaşa çenli (orun bilen)",
  newsletter_subscription: "Habarnama ýazylmak",
  newsletter_subscription_text: "Ähli möhüm habarlardan we amatly tekliplerden habarly bolmak üçin ýazylyň!",
  subscribe: "Ýazyl",
  successfully_subscribed: "Siz üstünlikli ýazyldyňyz!",
  subscription_error: "Ýazylmak ýalňyşlygy, soňrak gaýtadan synanyşyň!",
  all_news: "Ähli habarlar",
  tel: "Tel",
  enter_email: "E-poçtaňyzy giriziň",
  menu: "Menýu",
  settings: " Sazlamalar",
  deposit_method: "Goýum usulyny saýlaň",
  recharging_amount: "Doldurmagyň möçberi",
  recharge: " Doldur",
  recharging_balance: "Balansy doldurmak",
  done: " Taýýar",
  not_found_content: " Tapylmady",
  not_found_content_text: " Gynansak-da, bu mazmun saýlanan dilde elýeterli däl",
  airport_code: "Aeroportuň kody",
  from_city: "Nireden",
  to_city: "Haýsy şähere",
  weekdays: "Hepdäniň günleri",
  weekends: "Dynç günleri",
  weekends1: "1-nji we 2-nji ýanwar",
  weekends2: "8-nji we 21-nji mart",
  weekends3: "9-njy maý",
  weekends4: "1-nji sentýabr",
  weekends5: "1-nji oktýabr",
  weekends6: "8-nji we 31-nji dekabr",
  weekends7: "şeýle hem baýramçylyk günlerinde",
  airline: "Awiakompaniýa",
  min_number: "Möçber şundan uly bolmaly",
  only_numbers: " Diňe sanlar",
  must_register: " Saýtymyzda petek satyn almak üçin ulgama giren bolmaly",
  daily: "Her gün",
  fly_tagline: "Biz bilen uçmak aňsat",
  sorting: "Tertipleşdirmek",
  i_read_fares: "Men okadym",
  i_accept_fares: "we olaryň ählisini kabul edýärin",
  prices_table: "Bahalaryň tablisasy",
  continue: "Dowam et",
  reset_error_title: "Ýalňyşlyk",
  reset_error_content: "Bagyşlaň, soragyňyz işlenende ýalňyşlyk ýüze çykdy",
  reset_success_title: "Parolyňyzy üstünlikli üýtgetdiňiz",
  page_my_transactions: "Ýerine ýetirilen tölegler boýunça hasabat",
  reset_success_content: "Täze parol bilen girmek üçin «Giriş» düwmesine basyň",
  forgot_success_title: "Üstünlik!",
  forgot_success_content: "Dikeldiş salgysy e-poçtaňyza iberildi",
  forgot_error_title: "Ýalňyşlyk",
  forgot_error_content: "Bagyşlaň, e-poçtany nädogry girizdiňiz",
  password_confirm: "Paroly tassyklamak",
  password_confirm_error: "Parollar gabat gelmeýär",
  enter_password_confirm: "Paroly tassyklaň",
  reset_password: "Ulanyjynyň parolyny dikeltmek",
  mail_sent: "Hat iberildi!",
  enter_new_password: "Täze parolyňyzy giriziň",
  forgot_password: "Paroly unutdyňyzmy?",
  forgot_password_summary: "Paroly dikeltmek üçin e-poçtaňyzy giriziň",
  password_recovery_text:
    "Saýtymyzda hasaba alnan e-poçta salgyňyzy giriziň. Girişi dikeltmek üçin size salgy ibereris",
  password_recovery_confirm_text: "Dikeltmek üçin salgy bolan haty size iberdik",
  popup_event_text: "Hasaba durandan soň şahsy hasabyňyzyň balansyna 100 somoni bonus alyň",
  popup_description: "Saýtda hasaba duruň we öýden çykman onlaýn petek satyn alyň!",
  from_airport: "Aeroportdan",
  not_enough_balance: "Töleg üçin balans ýeterlik däl",
  questions_and_answers: "Soraglar we jogaplar",
  payment_methods: "Töleg usullary",
  our_partners: "Biziň hyzmatdaşlarymyz",
  confirm_actions: "Saýtdaky hereketiňizi tassyklaň",
  payer_contacts: "Töleýjiniň habarlaşmak maglumatlary",
  buyer_email: "Satyn alyjynyň e-poçtasy",
  enter_buyer_email: "Satyn alyjynyň e-poçtasyny giriziň",
  locator_order_number_or_booking_number: "Lokator, sargydyň belgisi ýa-da bronyň belgisi",
  enter_locator_order_number_or_booking_number: "Lokatory, sargydyň belgisini ýa-da bronyň belgisini giriziň",
  activate: "Işjeňleşdir",
  register: "Hasaba dur",
  deals: "Amatly teklipler",
  pre_cashback: "Awiapetek satyn alyň we bellenen",
  partners: "Hyzmatdaş awiakompaniýalar",
  scoreborad: "Aeroportlaryň onlaýn tablosy",
  cashback0: "Göni şertnama. Bahalar awiakompaniýalardan",
  cashback_from:
    "Taslamanyň hyzmatdaş awiakompaniýalaryndan keşbek Özbegistanyň aeroportlaryndan uçuşlara ulanylýar. Keşbek tarifden hasaplanýar.",
  cashback_from_in:
    "Taslamanyň hyzmatdaş awiakompaniýalaryndan keşbek Özbegistanyň aeroportlaryna we aeroportlaryndan uçuşlara ulanylýar. Keşbek tarifden hasaplanýar.",
  tarif: "tarifden",
  post_cashback: "şahsy hasabyňyzyň balansyna",
  cashback_message: "Keşbek almak üçin saýtda hasaba durup, petekleri hyzmatymyz arkaly satyn almaly. ",
  cashback_message_auth: "Size şu keşbek teklipleri elýeterli:",
  page_home: "Kassa barmazdan onlaýn petek satyn almak.",
  page_faq: "Meşhur soraglara jogaplar",
  page_login: "Şahsy hasabyňyza giriň",
  page_registration: "Hasaba duruň we petek satyn alyň",
  page_results: "Gyzyklanýan ugruňyz boýunça netijeler",
  page_booking: "Saýlanan petegi bronlaşdyrmak",
  page_order: "Ýerine ýetirilen sargyt barada maglumat",
  page_orders_list: "Ýerine ýetirilen sargytlar barada maglumat",
  page_my_profile: "Şahsy maglumatlar",
  page_add_balance: "Şahsy hasabyň balansyny doldurmak",
  page_popular_destinations: "Meşhur ugurlaryň tertibi",
  page_news: "Meşhur awiasiýa habarlary",
  page_forgot_password: "Öýden çykman onlaýn awiapetek satyn almak!",
  page_reset_password: "Öýden çykman onlaýn awiapetek satyn almak!",
  useful_info: "Peýdaly maglumat",
  copy_link: "Salgyny göçür",
  copy_text: "Teksti göçür",
  text_copied: "Göçürildi",
  copy_order_link_text: "Bu sargyda girişi paýlaşmak üçin salgyny göçüriň",
  link_copied_to_clipboard: "Salgy alyş-çalyş buferine göçürildi",
  unsubscribe_success: "Siz ýazylmagy üstünlikli ýatyrdyňyz",
  unsubscribe_error: "Sorag işlenende ýalňyşlyk ýüze çykdy",
  activation_code_send_to_email: "Tassyklaýyş kody e-poçta salgyňyza iberiler",
  choose_gender: "Jynsy saýlaň",
  old_information: "Maglumat könelişdi!",
  refresh: "Täzele",
  refresh_page: "Awiapetekleriň bahalary günde birnäçe gezek täzelenýär. Häzirki bahalary görmek üçin sahypany täzeläň.",
  will_take_2_minutes: "Bu biraz wagt alyp biler",
  error_additional_options_text:
    "Bronlaşdyrmak üçin goşmaça mümkinçilikleri açanda ýalňyşlyk ýüze çykdy. Goşmaça mümkinçilikler bolmazdan dowam edilsinmi?",
  edit_personal_data: "Şahsy maglumatlaryňyzy üýtgediň",
  minimum_amount: "Iň az möçber",
  additional_options: "Goşmaça mümkinçilikler",
  additional_options_not_found: "Goşmaça mümkinçilikler tapylmady!",
  profile_changed: "Profil üstünlikli üýtgedildi",
  welcome: "Hoş geldiňiz",
  register_on_somon_air: "Somon Air-da hasaba duruň",
  min_6_symbol: "Iň azyndan 6 belgi",
  your_id: "Siziň ID-ňiz",
  cheapest_without_baggage: "Bagažsyz iň arzan",
  cheapest_with_baggage: "Bagaž bilen iň arzan",
  most_convenient_transfes: "Iň amatly aralyk düşelge",
  fly_ru_tagline: "Dünýäniň tagamyny duýuň!",
  fly_ru_subtagline: "Dünýäniň ähli awiakompaniýalaryna girişiňiz",
  fly_ru_round_the_clock: "24/7",
  refund_order: "Yzyna gaýtarmak arzasy",
  refund_reason: "Yzyna gaýtarmagyň sebäbi",
  order_payment_method: "Sargydyň töleg usuly",
  payer_user_id: "Töleýjiniň ID-si",
  four_last_digits_of_card: "Kartanyň soňky 4 sany",
  user_id: "Ulanyjynyň ID-si",
  buyer_phone: "Satyn alyjynyň telefony",
  requisite_of_account_to_return: "Pul gaýtarmak üçin bank hasabynyň belgisi",
  requisite_of_account: "Bank hasabynyň belgisi",
  passenger_name_and_surname: "Ýolagçynyň doly ady",
  passport_serial_and_number: "Pasportyň seriýasy we belgisi",
  passport_copy: "Pasportyň nusgasy",
  send: "Iber",
  payment_from_client_balance: "Balans arkaly töleg",
  payment_from_card: "Karta arkaly töleg",
  vasl_tagline: "Amatlylyk — ileri tutulýan zat!",
  technical_support: "Tehniki goldaw",
  success_refund_order_request: "Yzyna gaýtarmak soragy üstünlikli iberildi!",
  error_refund_order_request: "Yzyna gaýtarmak soragyny ibermek ýalňyşlygy!",
  find_options: "Görnüşleri tap",
  buy_tickets_to_all_destinations: "we ähli ugurlara petek satyn alyň!",
  filters: "Süzgüçler",
  operation_type: "Amalyň görnüşi",
  all_operations: "Ähli amallar",
  balance_operation: "Balans amaly",
  order_payment: "Sargydyň tölegi",
  apply_filters: "Süzgüçleri ulan",
  export: "Eksport",
  view_manage_transactions: "Amallaryňyzyň taryhyny görüň we dolandyryň",
  no_transactions: "Sizde amal ýok!",
  showing: "Görkezilýär",
  of_total: "jemi",
  transactions_count: "amal",
  previous: "Öňki",
  date_and_time: "Sene we wagt",
  merchant: "Merçant",
  type: "Görnüşi",
  search_by_order: "Sargyt boýunça gözleg...",
  recharge_balance: "Balansy doldurmak",
  add_funds_securely: "Hasabyňyza serişdeleri howpsuz goşuň",
  select_payment_method: "Töleg usulyny saýlaň",
  quick_amounts: "Çalt möçberler",
  important_information: "Möhüm maglumat",
  minimum_recharge: "Iň az doldurma",
  maximum_recharge: "Iň köp doldurma",
  processing_time: "Işleniş wagty",
  instant: "Dessine",
  no_additional_fees: "Goşmaça ýygym ýok",
  recent_recharges: "Soňky doldurmalar",
  no_recent_recharges: "Soňky doldurma ýok",
  max_number: "Möçber şundan kiçi bolmaly",
  night_flight: "Gijeki aralyk düşelge",
  change_airport: "Aeroport çalyşmak",
  and: "we",
  from: "başlap",
  refund_order_success: "Yzyna gaýtarmak arzasy üstünlikli iberildi",
  refund_order_error: "Arza iberilende ýalňyşlyk ýüze çykdy",
  buy_tour: "Tur satyn al",
  payment_alert: "Hormatly ulanyjy, sargydyňyz tölendi. Resmileşdiriş wagty 1 minut.",
  customer_office_address: "Müşderi ofisiniň salgysy",
  inner_document: "Içerki resminama",
  inner_links: "Okamagy maslahat berýäris",
  document_copy: "Resminamanyň nusgasy",
  maximum_amount: "Iň köp möçber",
  search_limits_exceeded: "Hormatly ulanyjy, gözlegiň çägini aşdyňyz, dowam etmek üçin ulgama giriň",
  flight_without_seats: "Bagyşlaň, bu uçuşda boş orun galmady.",
  document_type: "Resminamanyň görnüşi",
  document_number: "Resminamanyň belgisi",
  expiration_date: "Hereket ediş möhleti",
  any_cabin: "Islendik klas",
  my: "Meniň",
  site: "Saýt",
  show_more: "Köpräk görkez",
  route: "Ugur",
  pay_before: "Şu wagta çenli töläň",
  price_expired_title: "Bahalaryň möhleti geçdi",
  price_expired_text: "Siz ýok wagtyňyz bahalaryň möhleti geçen bolmagy mümkin, soňky bahalary görmek üçin sahypany täzeläň.",
  price_expired_button: "Sahypany täzele",
  price_changed_title: "Baha üýtgedi",
  price_changed_text_up: "Siz sargydy resmileşdirýän wagtyňyz awiakompaniýa uçuşyň bahasyny üýtgetdi. Täze baha öňkiden ýokary.",
  price_changed_text_down: "Siz sargydy resmileşdirýän wagtyňyz awiakompaniýa uçuşyň bahasyny üýtgetdi. Täze baha öňkiden pes.",
  price_changed_old: "Öňki baha",
  price_changed_new: "Täze baha",
  price_changed_question: "Täze baha bilen dowam etmelimi?",
  price_changed_agree: "Razy, dowam et",
  price_changed_disagree: "Razy däl, gözlege gaýt",
  price_changed_moved_again: "Baha ýene üýtgedi. Täze mukdary barlaň we gaýtadan tassyklaň.",
  price_changed_update_error: "Bahany täzeläp bolmady. Täzeden synanyşyň.",
  price_changed_loading: "Baha täzelenýär…",
  price_changed_prebook_text_up: "Gözlegden soň awiakompaniýa bu uçuşyň bahasyny üýtgetdi. Täze baha öňkiden ýokary.",
  price_changed_prebook_text_down: "Gözlegden soň awiakompaniýa bu uçuşyň bahasyny üýtgetdi. Täze baha öňkiden pes.",
  price_changed_prebook_question: "Täze baha bilen bronlamagy dowam etmelimi?",
  price_changed_prebook_disagree: "Razy däl, gözlegi täzele",
  prebook_flight_unavailable: "Uçuş indi elýeterli däl: orun ýa-da saýlanan tarif galmady. Gözlegi täzeden geçiriň.",
  get_visa_title: "Wizanyň gerekdigini ýa-da gerek däldigini aýdyp bereris",
  get_visa_subtitle: "Nirä barýandygyňyzy görkeziň",
  get_visa_result_title: "Wiza talaplary bilen tanyşmaga taýýarmy?",
  get_visa_result_desc: "Häzirki wiza maglumatyny almak üçin raýatlygyňyzy we barýan ýurduňyzy saýlaň",
  select_citizenship: "Raýatlygyňyzy saýlaň",
  select_placeholder_citizenship: "Siziň raýatlygyňyz",
  select_destination: "Barýan ýurduňyzy saýlaň",
  select_placeholder_destination: "Barýan ýurdy",
  get_visa_loading_message: "Wiza talaplary barlanýar...",
  in_house: "Içerki uçuşlar üçin wiza gerek däl",
  no_country: "Ýurt tapylmady",
  no_data: "Maglumat ýok.",
  check_console_website: "Konsullygyň saýtyny barlaň.",
  no_visa: "Wiza gerek däl",
  no_visa_14: "14 güne çenli wiza gerek däl",
  no_visa_15: "15 güne çenli wiza gerek däl",
  no_visa_21: "21 güne çenli wiza gerek däl",
  no_visa_28: "28 güne çenli wiza gerek däl",
  no_visa_30: "30 güne çenli wiza gerek däl",
  no_visa_60: "60 güne çenli wiza gerek däl",
  no_visa_90: "90 güne çenli wiza gerek däl",
  no_visa_180: "180 güne çenli wiza gerek däl",
  no_visa_360: "360 güne çenli wiza gerek däl",
  no_restrictions: "Girişde çäklendirme ýok",
  visa_on_arrival: "Pasport barlagynda resmileşdirilýär",
  e_visa: "Elektron wiza",
  visa_required: "Wiza talap edilýär",
  check_council: "Şertleri konsullygyň saýtynda barlaň",
  to_pay_title: "Tölenmeli jemi",
  flight_selection: "Uçuş saýlamak",
  passenger_details: "Ýolagçynyň maglumatlary",
  base_fare: "Esasy tarif",
  processing_fee: "Resmileşdiriş ýygymy",
  taxes_and_fees: "Salgytlar we ýygymlar",
  includes_service_charges: "Awiakompaniýanyň salgytlary we aeroport ýygymlary",
  service_fee: "Hyzmat ýygymy",
  allowed: "Rugsat berilýär",
  non_refundable: "Yzyna gaýtarylmaýar",
  non_exchangeable: "Çalşylmaýar",
  contact_operator: "Operator bilen habarlaşyň",
  direct_flight: "Göni uçuş",
  processing: "Işlenilýär",
  incorrect_client_login: "E-poçta ýa-da parol nädogry",
  login_error: "Giriş ýalňyşlygy. Gaýtadan synanyşyň",
  login_exist: "Bu e-poçtaly ulanyjy eýýäm bar",
  unable_to_send_email: "Beýle e-poçta ýok",
  registration_error: "Hasaba durmak ýalňyşlygy. Gaýtadan synanyşyň",
  not_exist_or_not_active_user: "Ulanyjy tapylmady ýa-da işjeň däl",
  password_reset_error: "Paroly dikeltmek ýalňyşlygy. Gaýtadan synanyşyň",
  baggage_not_included: "Bagaž goşulmaýar",
  hand_luggage_not_included: "El goşy goşulmaýar",
  clarify_weight_contact_operator: "El goşunyň ýa-da bagažyň takyk agramyny anyklamak üçin operator bilen habarlaşyň",
  travel_disclaimer_title: "Ýolagçylar üçin möhüm maglumat",
  travel_disclaimer:
    "Wiza, migrasiýa, saglyk we beýleki giriş talaplary barada maglumat öňünden habar berilmezden üýtgäp biler. Ýolagçylar häzirki giriş, çykyş we üstaşyr geçiş düzgünlerini resmi çeşmelerden özbaşdak barlamaga hem-de syýahat üçin ähli zerur resminamalaryň bardygyna göz ýetirmäge jogapkärdir. Zerur resminamalaryň ýoklugy ýa-da hakyky däldigi üçin jogapkärçilik diňe ýolagçynyň üstüne düşýär.",
  payment_milly: "«Korti milli» bilen töleg",
  visa_on_arrival_desc: "Pasport barlagynda resmileşdirilýär",
  // заявка на возврат
  refund_request_subtitle: "Formany dolduryň we yzyna gaýtarmak arzasyny goşuň. Sargydy barlap, siziň bilen habarlaşarys.",
  order_number_label: "Sargyt belgisi",
  enter_order_number: "Sargyt belgisini giriziň",
  enter_refund_reason: "Yzyna gaýtarmagyň sebäbini ýazyň",
  refund_requisites_hint: "Meselem: kart ýa-da hasap belgisi, bank, alyjy",
  refund_document: "Yzyna gaýtarmak arzasy / resminamanyň nusgasy",
  refund_document_hint: "PDF, DOC, DOCX, JPG ýa-da PNG, 10 MB-a çenli",
  choose_file: "Faýl saýlamak",
  file_not_chosen: "Faýl saýlanmady",
  file_required: "Faýl goşuň",
  file_too_large: "Faýl 64 MB-dan uly",
  file_wrong_format: "Faýl formaty goldanylmaýar",
  refund_request_sent_text: "Arzaňyz kabul edildi. Sargydyň ýagdaýy «Yzyna gaýtarmak arzasy» bolar, barlagdan soň siziň bilen habarlaşarlar.",
  refund_status_not_suitable: "Bu sargyt üçin yzyna gaýtarmak arzasy elýeterli däl: petekler entek berilmedi ýa-da yzyna gaýtarmak eýýäm resmileşdirildi.",
  refund_passengers_label: "Gaýtarylýan ýolagçylar",
  refund_passenger_refunded: "Gaýtaryldy",
  refund_passenger_in_request: "Arza eýýäm iberildi",
  refund_passengers_hint: "Gaýtarmaly ýolagçylary belläň. Bäbek uly adam bilen bile gaýtarylýar.",
  refund_select_passenger_required: "Iň bolmanda bir ýolagçy saýlaň",
  refund_infant_without_adult: "Bäbek sargytda uly adamsyz galyp bilmeýär: ony uly adam bilen bile gaýtaryň.",
  refund_passengers_invalid: "Saýlanan ýolagçylar eýýäm gaýtaryldy ýa-da sargyda degişli däl.",
  to_orders: "Sargytlaryma",
  request_refund: "Yzyna gaýtarmak arzasy",
  optional_field: "hökmany däl",
  payment_commission_title: "Tölenmeli mukdar üýtgedi",
  payment_commission_text: "«{{method}}» arkaly tölänizde töleg ulgamy komissiýa alýar — ol sargyt mukdaryna goşuldy.",
  payment_commission_order_amount: "Sargydyň bahasy",
  payment_commission_fee: "Töleg ulgamynyň komissiýasy",
  payment_commission_total: "Tölemeli",
  payment_commission_hint: "Komissiýasy az ýa-da komissiýasyz başga töleg usulyny saýlap bilersiňiz.",
  payment_commission_ok: "Düşnükli",
  payment_commission_choose_other: "Başga usuly saýlamak",
  payment_commission_to_pay: "Komissiýa bilen tölemeli",
  // дополнительные услуги к заказу (eSIM, багаж и т.п.)
  additional_options_hint: "Tölegden öň sargyda goşup bolýar. Hyzmatlar tölegden soň resmileşdirilýär, resminamalar bilet bilen bile gelýär.",
  add_option: "Goşmak",
  remove_option: "Aýyrmak",
  price_on_request: "Bahasy haýyş boýunça",
  additional_options_error: "Goşmaça hyzmatlary üýtgedip bolmady, täzeden synanyşyň",
  additional_options_total: "Goşmaça hyzmatlar",
  additional_options_price_changed: "Goşmaça hyzmatlaryň bahasy üýtgedi. Sargydyň täze jemini barlaň we täzeden töläň.",
  seats_choose: "Orunlary saýlamak",
  seats_hide_map: "Shemany gizlemek",
  seats_not_selected: "Orunlar saýlanmadyk",
  meal_current_replace: "Häzir: {{meal}} — başgasyny saýlasaňyz, ol çalşylar",
  seat_not_selected: "orun saýlanmadyk",
  seat_free_of_charge: "Mugt",
  seat_occupied: "Eýelenen",
  seat_exit_row: "awariýa çykalgasy",
  passenger: "Ýolagçy",
  payment_checking_notice: "Tölegiňizi barlaýarys. Eger eýýäm tölän bolsaňyz, gaýtadan tölemäň — sargydyň ýagdaýy awtomatik täzelener.",
};

export default tm;
